import React, { PureComponent } from 'react'
import { Trans, withTranslation } from '@mc/i18n'
import {
  trackSocialVendorLogInInitiated,
  CheckoutEvents,
  EMAIL_STARTED_TYPES,
} from '@mc/pre-paywall-events'
import { ClarifyMultipleProfilesAtSignUpMessage } from '../ClarifyMultipleProfilesAtSignUpMessage'
import FacebookButton from '../FacebookButton'
import GoogleButton from '../GoogleButton'
import FormFields from './FormFields'

class RegisterForm extends PureComponent {
  static defaultProps = {
    title: 'Create Account',
  }

  handleGoogleSignUp = () => {
    trackSocialVendorLogInInitiated({
      pageSource: CheckoutEvents.PAGES.ACCOUNT_CREATION,
      vendor: EMAIL_STARTED_TYPES.GOOGLE,
    })
  }

  handleFacebookSignUp = () => {
    trackSocialVendorLogInInitiated({
      pageSource: CheckoutEvents.PAGES.ACCOUNT_CREATION,
      vendor: EMAIL_STARTED_TYPES.FACEBOOK,
    })
  }

  render() {
    const { facebookSignUp, title, subtitle, t, userAgent } = this.props

    return (
      <div>
        <h4 className='mc-text-h4 mc-text--center mc-mb-6'>{title}</h4>
        {subtitle && (
          <p className='mc-text--center mc-mb-6 mc-opacity--muted'>
            {subtitle}
          </p>
        )}
        <div className='mc-mb-4'>
          <GoogleButton userAgent={userAgent} onClick={this.handleGoogleSignUp}>
            {t('registerForm.google')}
          </GoogleButton>
        </div>

        <div className='mc-mb-4'>
          <FacebookButton
            onLogin={facebookSignUp}
            userAgent={userAgent}
            onClick={this.handleFacebookSignUp}
          >
            {t('registerForm.facebook')}
          </FacebookButton>
        </div>

        <ClarifyMultipleProfilesAtSignUpMessage />
        <div className='mc-mb-4'>
          <p className='mc-text-hr mc-text-x-small mc-opacity--muted mc-text--uppercase mc-mt-3'>
            <Trans i18nKey='registerForm.or' ns='@mc/authentication'>
              <span></span>
            </Trans>
          </p>
        </div>

        <FormFields {...this.props} />
      </div>
    )
  }
}

/** @type {React.ComponentType<any>} */
const WrappedRegisterForm = withTranslation('@mc/authentication')(RegisterForm)
export default WrappedRegisterForm
